import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getDiscountPrice } from "../../../helpers/product";
import { deleteFromCart } from "../../../store/slices/cart-slice";

const MenuCart = () => {
  const dispatch = useDispatch();
  const currency = useSelector((state) => state.currency);
  const { cartItems = [] } = useSelector((state) => state.cart || {});
  let cartTotalPrice = 0;

  return (
    <div className="shopping-cart-content">
      {Array.isArray(cartItems) && cartItems.length > 0 ? (
        <Fragment>
          <ul>
            {cartItems.map((item) => {
              const discountedPrice = getDiscountPrice(
                item.price,
                item.discount
              );
              const finalProductPrice = (
                item.price * currency.currencyRate
              ).toFixed(2);
              const finalDiscountedPrice = discountedPrice
                ? (discountedPrice * currency.currencyRate).toFixed(2)
                : null;

              discountedPrice != null
                ? (cartTotalPrice += finalDiscountedPrice * item.quantity)
                : (cartTotalPrice += finalProductPrice * item.quantity);

              const imageUrl =
                Array.isArray(item.image) && item.image.length > 0
                  ? item.image[0]
                  : Array.isArray(item.images) && item.images.length > 0
                  ? item.images[0].image
                  : "/assets/img/no-image.png";

              return (
                <li className="single-shopping-cart" key={item.cartItemId}>
                  <div className="shopping-cart-img">
                    <Link to={`${process.env.PUBLIC_URL}/product/${item.id}`}>
                      <img
                        alt={item.name}
                        src={imageUrl}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link
                        to={`${process.env.PUBLIC_URL}/product/${item.id}`}
                      >
                        {item.name}
                      </Link>
                    </h4>
                    <h6>Qty: {item.quantity}</h6>
                    <span>
                      {discountedPrice !== null
                        ? "$" + finalDiscountedPrice
                        : "$" + finalProductPrice}
                    </span>
                    {item.selectedProductColor && item.selectedProductSize && (
                      <div className="cart-item-variation">
                        <span>Color: {item.selectedProductColor}</span>
                        <span>Size: {item.selectedProductSize}</span>
                      </div>
                    )}
                  </div>
                  <div className="shopping-cart-delete">
                    <button
                      onClick={() =>
                        dispatch(deleteFromCart(item.cartItemId))
                      }
                    >
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="shopping-cart-total">
            <h4>
              Total :{" "}
              <span className="shop-total">
                {"$" + cartTotalPrice.toFixed(2)}
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={`${process.env.PUBLIC_URL}/cart`}>
              View cart
            </Link>
            <Link
              className="default-btn"
              to={`${process.env.PUBLIC_URL}/checkout`}
            >
              Checkout
            </Link>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">No items added to cart</p>
      )}
    </div>
  );
};

export default MenuCart;
